import script from "./PaginaPrincipal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginaPrincipal.vue?vue&type=script&lang=ts&setup=true"

import "./PaginaPrincipal.vue?vue&type=style&index=0&id=9cb7444e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cb7444e"]])

export default __exports__